import { render, staticRenderFns } from "./CropImage.vue?vue&type=template&id=2c6b0390&scoped=true&"
import script from "./CropImage.vue?vue&type=script&lang=js&"
export * from "./CropImage.vue?vue&type=script&lang=js&"
import style0 from "./CropImage.vue?vue&type=style&index=0&id=2c6b0390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b0390",
  null
  
)

export default component.exports